<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 23:47:06
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/milkplan/components/PlanSelectAddress/index.vue
-->
<template>
  <div>
    <!-- 修改地址弹窗 -->
    <van-overlay :show="show" @click="closeBg">
      <div class="wrapper">
        <div class="block">
          <div class="dio_title">修改地址</div>
          <div class="dio_item" @click="goAddressList('one')">当前配送周期</div>
          <div class="dio_item" @click="goAddressList('all')">
            所有未配送周期
          </div>
          <div class="dio_cancel" @click="closeBg">取消</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true
    };
  },
  methods: {
    closeBg() {
      // console.log(1111111);
      this.show = true;
      this.$emit("closeBg");
    },
    goAddressList(key) {
      this.$emit("goAddressList", key);
    }
  }
};
</script>

<style lang="less" scoped>
// 地址弹窗
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 28px;
}

.block {
  width: 100%;
  /* height: 30%; */
  border-radius: 10px;
  text-align: center;
  background-color: #fff;
}
.dio_title {
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  padding: 32px 0;
  color: #222;
  border-bottom: 1px solid #e7e7e7;
}
.dio_item {
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  padding: 16px 0;
  color: rgba(183, 130, 65, 1);
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
}
.dio_cancel {
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  padding: 16px 0;
  color: #222;
}
</style>
